import { render, staticRenderFns } from "./PageVenueFilter.vue?vue&type=template&id=0dd18905&"
import script from "./PageVenueFilter.vue?vue&type=script&lang=js&"
export * from "./PageVenueFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports